/**
 * 公共方法
 */
exports.install = function (Vue,options){
        var _this=Vue.prototype;
        var CommonJs=Vue.prototype.$commonJs={};
        /**
         * 在新页面打开
         * @param {*} $this
         * @param {*} routeName
         * @param {*} param 参数对象，对象格式
         * */
        //列表查询筛选
        CommonJs.beforeAvaUpload=function(file) {
            const isJPG = file.type === 'image/jpeg' || file.type=== 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$emit('handleImgTips','上传图片只能是 JPG/png 格式!')
                return false
            }
            if (!isLt2M) {
                 alert('上传图片大小不能超过 10MB!')
                // this.$emit('handleImgTips','上传图片大小不能超过 10MB!')
                return false
            }
            return isJPG && isLt2M;
        }

        //列表查询筛选
        CommonJs.filterHandler=function(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        }


        //下载
         CommonJs.downExcel =function(that,mult,param,url) {
                if(mult && mult.length>0){
                    let ids = mult.map(item => item.id).join();
                    var params={ids:ids}
                }else{
                    var params = Object.assign({}, param);
                }
                that.loadingExcel = true;
                Vue.http.get(url,{
                    responseType:'blob',      //告诉服务器我们需要的响应格式
                    params:params,
                    headers: {
                        "token":localStorage["token_trade_manage"],
                     }
                })
                .then(res => {
                    that.loadingExcel = false;
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href",objectUrl);
                    // a.setAttribute("download", '著作权.xls');
                    a.click();
                })
                .catch(err => {
                    that.loadingExcel = false;
                    that.$message({ message: "执行失败，请重试", type: "error" });
                })
        },


        //产品 更新
        CommonJs.updateProduct = function(that,row){
            let params = {
                skuType:row.skuType,
                skuId:row.id,
            }
             let url = '/jbbcs/organiza/updateProduct'
             that.$confirm("此操作将更新产品", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                    Vue.http.post(url,params,{
                        headers: {
                           "token":window.localStorage.getItem("token_trade_manage"),
                        },
                    })
                    .then(res => {
                            if(res.data.code==1){
                                that.productSearch();
                                that.$message.success(res.data.msg);
                            }else if(res.data.code==0){
                                that.$message({ message: res.data.msg, type: "error" });
                            }
                    })
                    .catch(err => {
                        that.$message({ message: "执行失败，请重试", type: "error" });
                    })
            })
            .catch(() => {
                that.$message({ type: "info", message: "已取消操作" });
            });

        },

        //跟进记录
        CommonJs.getGenJinVal =function(keyId,keyType) {
                let param = {
                    customerId:'',
                    orderId:'',
                    keyId:keyId,
                    keyType:keyType,
                }
                Vue.http.get('/jbbcs/manage/traceLog/getTraceLogList.do',{
                    responseType:'blob',      //告诉服务器我们需要的响应格式
                    params:param,
                    headers: {
                        "token":window.localStorage.getItem("token_trade_manage"),
                     },
                })
                .then(res => {
                    console.log(res)
                    if(res.data.code==1){
                        return res.data.content  
                    }else if(res.data.code==0){
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    that.$message({ message: "执行失败，请重试", type: "error" });
                })
        }





}



// WEBPACK FOOTER //
// ./src/common/common.js